import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {OfferGoalType} from '../../models/offer-goal-type';

@Injectable({
  providedIn: 'root'
})
export class OfferGoalTypeService extends AbstractModelService<OfferGoalType> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/offer-goal-type', OfferGoalType);
  }
}
